(ns pfo.im.model
  (:require [pfo.api :as api]
            [clojure.string :as str]))

;; Conversation kinds
(def kind-direct "direct")
(def kind-group  "group")

;; Delivery statuses
(def status-sent      "sent")
(def status-delivered "delivered")
(def status-read      "read")

;; --- Data transformations ---

(defn current-user-id []
  (api/get-auth-info :user-id))

(defn message->ui [msg]
  (let [my-id (current-user-id)]
    {:id         (:id msg)
     :conv-id    (:conversation_id msg)
     :sender-id  (:sender_id msg)
     :content    (:body msg)
     :created-at (:created_at msg)
     :direction  (if (= (:sender_id msg) my-id) "outgoing" "incoming")}))

(defn conversation-display-name [conv current-user-id]
  (or (:name conv)
      (not-empty (->> (:participants conv)
                      (remove #(= (:user_id %) current-user-id))
                      (map #(str/trim (str (:first_name %) " " (:last_name %))))
                      (str/join ", ")))
      "Conversation"))

(defn unread-count [conv current-user-id]
  (let [last-read-id (->> (:participants conv)
                          (filter #(= (:user_id %) current-user-id))
                          first
                          :last_read_msg_id)]
    ;; Backend returns unread as count in participant — placeholder 0
    ;; Full implementation would compare last_read_msg_id with latest message id
    0))

(defn delivery-icon [status]
  (condp = status
    status-read      "✓✓"
    status-delivered "✓✓"
    status-sent      "✓"
    ""))

(defn delivery-status-class [status]
  (condp = status
    status-read      "is-read"
    status-delivered "is-delivered"
    nil))
